import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full justify-center" }

import { onMounted } from 'vue'
import Typed from 'typed.js'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const typedOptions = {
  strings: [
    "I'm an aspiring Software Engineer",
    "I'm a Computer Science and Mathematics student at Notre Dame",
    "I love turning my ideas into reality with code",
    'Welcome to my portfolio!' 
  ],
  contentType: 'html',
  typeSpeed: 75,
  backSpeed: 75,
  startDelay: 500,
  backDelay: 1000,
  loop: true,
  showCursor: false
}

onMounted(() => {
  new Typed(".auto-type", typedOptions)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"flex flex-col gap-4 items-center\" data-v-f5d49bae><h1 class=\"text-muted-green font-bold lg:text-8xl text-5xl font-Merriweather w-full\" data-v-f5d49bae> Hi! My name is <span class=\"font-bold name-text\" data-v-f5d49bae>Clair Green</span></h1><h1 class=\"min-h-[4.5rem]\" data-v-f5d49bae><span class=\"auto-type lg:text-5xl text-2xl font-normal font-Montserrat\" data-v-f5d49bae></span></h1></div>", 1)
  ])))
}
}

})